import { teamDetailSelector, useTeamStore } from 'modules/team';

export const useController = () => {
  const team = useTeamStore(teamDetailSelector);

  return {
    team,
  };
};
